import ImageComponent from '@spa/components/image-component/image.component';
import Link from 'next/link';
import { ReactElement } from 'react';
import classNames from 'clsx';
import styles from './simple-entries.module.scss';
export interface Entry {
  readonly label: string;
  readonly path: string | null;
  readonly items: ReadonlyArray<Entry>;
}
const normalizePath = (path: string | null): string => path?.replace(/\/$/, '') ?? '';
const isPathInChildren = (entries: ReadonlyArray<Entry>, currentPath: string): boolean => entries.some(({
  path,
  items
}) => normalizePath(path) === currentPath || isPathInChildren(items, currentPath));
const SimpleEntries = ({
  entries,
  currentPath
}: {
  entries: ReadonlyArray<Entry>;
  currentPath: string;
}): ReactElement => {
  return <>
      {entries.length > 0 ? <ul className={styles['simple-entries']}>
          {entries.map(({
        label,
        path,
        items
      }): ReactElement => {
        const isActive = normalizePath(path) === normalizePath(currentPath);
        const isCurrentInChildren = isPathInChildren(items, normalizePath(currentPath));
        const isDirectParent = isCurrentInChildren && !isActive;
        const shouldShowChildren = isActive || isCurrentInChildren;
        const itemClasses = classNames(styles['simple-entries__entry-content'], {
          [`${styles['simple-entries__entry-content--active']} bold`]: isActive
        });
        const navigationItem = <>
                <ImageComponent src={`/assets/icons/arrow_forward.svg`} height={15} width={15} alt="" className={classNames(styles['simple-entries__icon'], {
            [styles['simple-entries__icon--active']]: shouldShowChildren || isDirectParent
          })} />
                <span className={`${styles['simple-entries__text']}`}>{label}</span>
              </>;
        return <li key={path || label} className={styles['simple-entries__item']}>
                {path ? <Link prefetch={false} href={path} className={itemClasses}>
                    {navigationItem}
                  </Link> : <span className={itemClasses}>{navigationItem}</span>}

                {shouldShowChildren && items.length > 0 && <SimpleEntries entries={items} currentPath={currentPath} />}
              </li>;
      })}
        </ul> : null}
    </>;
};
export default SimpleEntries;